import React from "react";
import OriginOccurrences from "src/pages/Occurrences/Config/Origin";
import StepsOccurrences from "src/pages/Occurrences/Config/Steps";
import RequirementsOccurrences from "src/pages/Occurrences/Config/Requirements";
import CategoriesOccurrences  from "src/pages/Occurrences/Config/Categories";
import OccurrencesPanel from "src/pages/Occurrences/Panel";
import RoutePrivate from "./private";

export default [
	<RoutePrivate path="/occurrences/origins" key="occurrencesOrigins" exact component={OriginOccurrences} isPrivate/>,
	<RoutePrivate path="/occurrences/requirements" key="occurrencesRequirements" exact component={RequirementsOccurrences} isPrivate/>,
	<RoutePrivate path="/occurrences/categories" key="occurrencesCategories" exact component={CategoriesOccurrences} isPrivate/>,
	<RoutePrivate path="/occurrences/standardsteps" key="occurrencesStandardsteps" exact component={StepsOccurrences} isPrivate/>,
	<RoutePrivate path="/occurrences/panel" key="occurrencesPanel" exact component={OccurrencesPanel} isPrivate />,
	<RoutePrivate path="/occurrences/panel/:occurrenceId" permissionPath="/occurrences/panel" key="occurrencesPanelOccurrenceId" exact component={OccurrencesPanel} isPrivate />
];
